module.exports = __webpack_public_path__ + "static/media/em-44.d50c0dfd.png";